import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { adminPasswordUpdate } from '../../../api/redux/slices/Auth';
import './index.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ButtonComponent } from '../../../components/buttons/index';
import PasswordInput from '../../../components/passwordInput';
import { showToast } from '../../../components/modal';

const EditPassword = ({ resetPage }) => {
	const dispatch = useDispatch();

	const [isLoading, setisLoading] = useState(false);
	const [values, setValues] = useState({
		oldPassword: '',
		newPassword: '',
		confirmPassword: '',
	});

	const accesstoken = localStorage.getItem('accesstoken');

	const handleUpdate = (e) => {
		e.preventDefault();
		const data = {
			oldPassword: values.oldPassword,
			newPassword: values.newPassword,
			confirmPassword: values.confirmPassword,
		};
		if (!values.oldPassword || !values.newPassword || !values.confirmPassword) {
			showToast('Veuillez renseigner tous les champs', 'warn');
			return;
		}
		if (values.newPassword !== values.confirmPassword) {
			showToast('Mots de passe non identiques', 'warn');
			return;
		}
		setisLoading(true);
		dispatch(adminPasswordUpdate({ token: accesstoken, data: data }))
			.unwrap()
			.then((res) => {
				showToast(res.message, 'success');
				resetPage();
			})
			.catch((err) => {
				showToast(err.message, 'error');
			})
			.finally(() => setisLoading(false));
	};

	const handleCancel = (e) => {
		e.preventDefault();
		resetPage();
	};

	return (
		<div className='edit-password-container'>
			<div className='navbar'>
				<div className='left'>
					<h1>Modifier le mot de passe</h1>
				</div>
				<div className='right'>
					<div className='edit-profile-button'>
						<button
							className='button-nature'
							onClick={handleCancel}
						>
							Annuler
						</button>
						<ButtonComponent
							className='button-primary'
							loading={isLoading}
							type='submit'
							name={'Enregistrer'}
							onClick={handleUpdate}
						/>
					</div>
				</div>
			</div>

			<form onSubmit={handleUpdate} className='edit-password-form'>
				<div className='form-fields'>
					<div className='label-input'>
						<label>Entrer le mot de passe actuel</label>
						<PasswordInput
							id={'oldPassword'}
							placeholder={'Entrer le mot de passe actuel'}
							value={values.oldPassword}
							onChange={(e) => {
								setValues({ ...values, oldPassword: e.target.value });
							}}
						/>
					</div>

					<div className='label-input'>
						<label>Entrer le nouveau mot de passe</label>
						<PasswordInput
							id={'newPassword'}
							placeholder={'Entrer le nouveau mot de passe'}
							value={values.newPassword}
							onChange={(e) => {
								setValues({ ...values, newPassword: e.target.value });
							}}
						/>
					</div>

					<div className='label-input'>
						<label>Confirmer le nouveau mot de passe</label>
						<PasswordInput
							id={'confirmPassword'}
							placeholder={'Confirmer le nouveau mot de passe'}
							value={values.confirmPassword}
							onChange={(e) => {
								setValues({ ...values, confirmPassword: e.target.value });
							}}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default EditPassword;